(function(){
  var PT=/^pt/i.test(document.documentElement.lang||'');
  var L=PT?{save:'Poupas',saving:'Poupança'}:{save:'Ahorras',saving:'Ahorro'};
  function num(t){ if(!t) return NaN; return parseFloat(t.replace(/[^0-9,.-]/g,'').replace(/\./g,'').replace(',','.')); }
  function fmt(n){ return n.toFixed(2).replace('.',',')+' €'; }
  function lines(){
    document.querySelectorAll('.cart-items__table-row').forEach(function(row){
      var price=row.querySelector('.cart-items__price'); if(!price || price.dataset.nb) return;
      var was=row.querySelector('.cart-items__unit-price-wrapper .compare-at-price');
      var qtyIn=row.querySelector('input[type=number]'); var qty=qtyIn?parseInt(qtyIn.value,10)||1:1;
      var lineTxt=(price.querySelector('bdi')||price).textContent; var line=num(lineTxt);
      if(isNaN(line)) return;
      var full=was?num(was.textContent)*qty:line; var save=full-line;
      price.dataset.full=full.toFixed(2); price.dataset.line=line.toFixed(2);
      if(!(save>0.009)) { price.dataset.nb='0'; return; }
      price.dataset.nb='1';
      price.innerHTML='<span class="nb-line-was">'+fmt(full)+'</span><span class="nb-line-now">'+fmt(line)+'</span><span class="nb-line-save">('+L.save+' '+fmt(save)+')</span>';
    });
  }
  /* Resumen: «Ahorro» + «Total» */
  function summary(){
    document.querySelectorAll('.cart-totals__container').forEach(function(box){
      var scope=box.closest('cart-items-component')||box.closest('.cart-drawer__inner')||document;
      var totEl=box.querySelector('.cart-totals__total-value'); if(!totEl) return;
      var bdi=totEl.querySelector('bdi')||totEl;
      if(/\s*EUR\s*$/.test(bdi.textContent)) bdi.textContent=bdi.textContent.replace(/\s*EUR\s*$/,'');
      var total=num(bdi.textContent); if(isNaN(total)) return;
      var full=0, ok=false;
      scope.querySelectorAll('.cart-items__price[data-full]').forEach(function(p){ full+=parseFloat(p.dataset.full); ok=true; });
      var save=ok?full-total:0;
      var row=box.querySelector('.nb-sum-save');
      if(!row){ row=document.createElement('span'); row.className='cart-totals__item nb-sum-save'; box.insertBefore(row, box.firstChild); }
      var html=save>0.009?'<span>'+L.saving+'</span><b>-'+fmt(save)+'</b>':'';
      if(row.innerHTML!==html) row.innerHTML=html;
      row.style.display=html?'':'none';
      var lab=box.querySelector('.cart-totals__total-label'); if(lab && lab.textContent!=='Total') lab.textContent='Total';
    });
    document.querySelectorAll('.cart__checkout-button .button-text').forEach(function(b){ if(b.textContent.trim()!=='Finalizar compra') b.textContent='Finalizar compra'; });
  }
  var busy=false;
  function run(){ if(busy) return; busy=true; try{ lines(); summary(); } finally { busy=false; } }
  run();
  var t; new MutationObserver(function(){ clearTimeout(t); t=setTimeout(run,30); }).observe(document.body,{childList:true,subtree:true,characterData:true});
})();
